<main class="container-fluid">

    @if(doneLoading) {
        <div class="change-log-container">
            <div [innerHTML]="changeLogHtml"></div>
        </div>
    } @else {
        <div class="container">
            <div class="row justify-content-center col-sm-12">
                <p>loading changelog...</p>
            </div>
            <div class="row justify-content-center col-sm-12">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    }

</main>